import {createType, createAction} from 'store/utils';

const prefix = 'CORE_SETTINGS';

export const SET_REFILL_ENABLED = createType(prefix, 'SET_REFILL_ENABLED');
export const setRefillEnabled = (isEnabled: boolean): Action =>
  createAction(SET_REFILL_ENABLED, {isEnabled});
